import module from '@app/error/module'
import template from './template.html'
import './style.scss'

export class AppErrorNosoportadoComponent {
}

module.component('appErrorNosoportado', {
  controller: AppErrorNosoportadoComponent,
  template: template,
})



// WEBPACK FOOTER //
// ./src/app/error/components/nosoportado/component.js